/** Shared tag arrays reused across the catalog tiles that split into sub-types. */

export const liEventTags = [
	{
		label: "Better with LinkedIn Premium",
		information:
			"This feature is better with LinkedIn Premium. If you don't have LinkedIn Premium, you can still use this feature, but you might not be able to all attendees of events.",
	},
	{ label: "Uses your Linkedin account" },
];

export const liPeopleTags = [
	{
		label: "Better with LinkedIn Premium",
		information:
			"This feature works better with LinkedIn Premium. If you don't have LinkedIn Premium, you can still use this feature, but you might not be able to all search results.",
	},
	{ label: "Uses your Linkedin account" },
];

export const liSnTags = [
	{
		label: "Requires LinkedIn Sales Navigator",
		information: "This feature requires LinkedIn Sales Navigator by at least one user in your team",
	},
	{ label: "Uses your Linkedin account" },
];
